import { updatesData } from '@/mocks/home';

const tagStyleMap: Record<string, string> = {
  '最新': 'bg-accent-500/20 text-accent-400',
  '快讯': 'bg-secondary-500/20 text-secondary-400',
  '热点': 'bg-primary-500/20 text-primary-400',
  '突发': 'bg-primary-500/90 text-foreground-50',
  '跟进': 'bg-secondary-500/20 text-secondary-400',
  '独家': 'bg-accent-500/90 text-background-900',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-500/15 text-primary-400 text-xs font-medium mb-3 whitespace-nowrap">
            实时滚动
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            最新快讯
          </h2>
          <p className="text-foreground-500 text-sm mt-2 max-w-xl mx-auto">
            7×24小时不间断更新，重大黑料第一时间推送
          </p>
        </div>

        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-[15px] md:left-[19px] top-2 bottom-2 w-px bg-background-400/50" />

          <div className="flex flex-col gap-1">
            {updatesData.map((item, idx) => (
              <div key={item.id} className="relative flex items-start gap-4 md:gap-5 pl-10 md:pl-12 py-3 group">
                <div className={`absolute left-[11px] md:left-[15px] top-[18px] w-[9px] h-[9px] md:w-[11px] md:h-[11px] rounded-full border-2 flex-shrink-0 transition-all duration-300 group-hover:scale-125 ${
                  idx === 0 ? 'bg-primary-500 border-primary-500 animate-pulse' : 'bg-background-100 border-background-500 group-hover:border-primary-500'
                }`} />

                <span className="text-xs text-foreground-600 flex-shrink-0 w-[54px] md:w-[64px] pt-0.5 whitespace-nowrap">
                  {item.time}
                </span>

                <div className="flex-1 min-w-0 flex items-start gap-2 flex-wrap">
                  <span className={`px-1.5 py-0.5 rounded text-xs font-medium flex-shrink-0 whitespace-nowrap ${tagStyleMap[item.tag] || 'bg-secondary-500/20 text-secondary-400'}`}>
                    {item.tag}
                  </span>
                  <span className="text-foreground-300 text-sm md:text-base leading-relaxed group-hover:text-foreground-100 transition-colors">
                    {item.title}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}